module.exports = __webpack_public_path__ + "img/logo-driver.00d833a2.png";